<div class="text-center py-4 text-muted">
  <p class="mb-0 fs-6">
    <ng-content></ng-content>
  </p>
</div>
